export const environment = {
  production: false,
  envName: 'homologation',
  appName: 'Fortaris',
  version: '1.0.0',
  apiBaseUrl: 'https://api.fortaris.homo.inforcentersistemas.com/api/v1',
  requestTimeout: 30000,
  storageKeys: {
    token: 'fortaris.token',
    refreshToken: 'fortaris.refreshToken',
    user: 'fortaris.user'
  },
  pagination: {
    pageSize: 10,
    pageSizeOptions: [10, 20, 50, 100]
  },
  features: {
    enableDebug: false,
    enableConsoleLog: false
  }
};
